import styled from 'styled-components'
import topLeftImg from './images/gora-l.png'
import topRightImg from './images/gora-p.png'
import bottomLeftImg from './images/dol-l.png'
import bottomRightImg from './images/dol-p.png'
import {default as ResizableBox} from "react-resizable-box";

export const Resizable = styled(ResizableBox)`
  position: absolute !important;
  top: 0;
  left: 0;
`

export const ResizableInside = styled.div`
  width: ${props => props.w}px;
  height: ${props => props.h}px;

  border: ${props => (props.isResizing ? `4px dotted ${props.theme.colors.primary}` : 'none')};

  // & + .react-resizable-handle {
  //   width: 25px;
  //   height: 25px;
  //
  //   background-size: 100%;
  //   background: url(${bottomRightImg});
  // }
`

const Arrow = styled.span`
  width: 25px;
  height: 25px;
`

export const ArrowTopLeft = styled(Arrow)`
  top: 0;
  left: 0;
  background: url(${topLeftImg});
`

export const ArrowTopRight = styled(Arrow)`
  top: 0;
  right: 0;
  background: url(${topRightImg});
`

export const ArrowBottomRight = styled(Arrow)`
  bottom: 0;
  right: 0;
  background: url(${bottomRightImg});
`



// WEBPACK FOOTER //
// ./src/components/ResizableProduct/theme.js